<template>
    <div>
    <v-dialog v-model="isModalShowing" persistent width="550">
        <template v-slot:activator="{ on }">
            <span v-on="on">
                <slot />
            </span>
        </template>
        <v-card data-test="call-list-modal">
            <v-card-text class="message-type-section">
                <div class="message-type-container">
                    <label class="message-type-option" :class="{ active: messageTypeSelection === 'link' }">
                        <input 
                            type="radio" 
                            name="messageType" 
                            v-model="messageTypeSelection"
                            value="link"
                            class="message-type-radio"
                        >
                        <span class="message-type-label">{{ $t('modals.findByNumbersModal.byLink') }}</span>
                    </label>
                    <label v-show="teamId === 1" class="message-type-option" :class="{ active: messageTypeSelection === 'alert' }">
                        <input 
                            type="radio" 
                            name="messageType" 
                            v-model="messageTypeSelection"
                            value="alert"
                            class="message-type-radio"
                        >
                        <span class="message-type-label">{{ $t('modals.findByNumbersModal.byAlert') }}</span>
                    </label>
                    <!-- <label class="message-type-option" :class="{ active: messageTypeSelection === 'response' }">
                        <input 
                            type="radio" 
                            name="messageType" 
                            v-model="messageTypeSelection"
                            value="response"
                            class="message-type-radio"
                        >
                        <span class="message-type-label">{{ $t('modals.findByNumbersModal.byResponse') }}</span>
                    </label> -->
                    <v-select
                        v-model="picked"
                        :items="languageItems"
                        item-text="text"
                        item-value="value"
                        rounded
                        filled
                        dense
                        hide-details
                        style="max-width: 120px; font-size: 12px; margin-left: auto;"
                    ></v-select>
                    <v-select
                        v-show="messageTypeSelection === 'link'"
                        v-model="smsContentValue"
                        :items="smsContentItems"
                        item-text="text"
                        item-value="value"
                        rounded
                        filled
                        dense
                        hide-details
                        style="max-width: 120px; font-size: 12px; margin-left: auto;"
                    ></v-select>
                </div>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-text v-show="messageTypeSelection === 'link'">
                <input 
                    type="text"
                    class="input-group-field"
                    v-model="newNumbers"
                    @keyup.enter="addNumber"
                    :placeholder="$t('modals.findByNumbersModal.addNumberPlaceholder')"
                    style="font-weight: 500;text-align:center;"
                >
                <v-container class="numbers-container">
                    <div 
                        class="number-item"
                        v-for="(number, i) in numbers"
                        :key="i"
                    >
                        <span class="number-text">{{ number }}</span>
                        <v-btn 
                            class="remove-number-btn" 
                            icon 
                            x-small 
                            @click="removeNumber(number)"
                        >
                            <span class="remove-x">×</span>
                        </v-btn>
                    </div>
                </v-container>
            </v-card-text>
            <v-card-text v-show="messageTypeSelection === 'alert'" class="alert-mode-section">
                <span v-if="weaLink" class="input-group-field wea-link-field">{{ weaLink }}</span>
                <div v-if="weaLink" class="wea-link-actions">
                    <v-btn small color="secondary" @click="copyWeaLink">{{ $t('modals.addNumbersModal.copyLink') }}</v-btn>
                </div>
                <div v-if="weaLink" class="dispatcher-link-section">
                    <input
                        type="text"
                        class="input-group-field dispatcher-link-title-field"
                        v-model="newLinkTitle"
                        :placeholder="$t('modals.findByNumbersModal.addLinkTitlePlaceholder')"
                    >
                    <textarea
                        class="input-group-field dispatcher-link-field"
                        v-model="newLink"
                        rows="2"
                        :placeholder="$t('modals.findByNumbersModal.addLinkPlaceholder')"
                    ></textarea>
                    <v-btn
                        small
                        color="primary"
                        class="save-agency-link-btn"
                        :loading="agencyLinkSaving"
                        :disabled="!newLink.trim() || agencyLinkSaving"
                        @click="saveAgencyLandingLink"
                    >
                        {{ agencyLinkSaved ? $t('modals.findByNumbersModal.agencyLinkSaved') : $t('modals.findByNumbersModal.saveAgencyLink') }}
                    </v-btn>
                </div>
                <br/>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-btn medium text @click="cancelModal">{{ $t('modals.findByNumbersModal.cancel') }}</v-btn>
                <v-spacer />
                <v-btn v-if="messageTypeSelection === 'link'" medium @click="commitAndSubmitNumbers" color="primary">{{ $t('modals.findByNumbersModal.sendSms') }}</v-btn>
                <v-btn v-if="messageTypeSelection === 'alert' && !weaLink" medium @click="createWEALink" color="primary">Get Link</v-btn>
                <v-btn v-if="messageTypeSelection === 'alert' && weaLink" medium @click="closeModal" color="primary">Close</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <v-dialog v-model="isCustomModalOpen" persistent width="500">
        <v-card>
            <v-card-title><h5>{{ $t('modals.findByNumbersModal.customSmsTitle') }}</h5></v-card-title>
            <v-divider></v-divider>
            <v-card-text>
                <v-textarea
                    v-model="customSmsText"
                    filled
                    dense
                    hide-details
                    style="padding: 20px 0;font-size: 15px;"
                ></v-textarea>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-btn medium text @click="cancelCustomModal">{{ $t('modals.findByNumbersModal.cancel') }}</v-btn>
                <v-spacer />
                <v-btn medium color="primary" @click="saveCustomModal">Save</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    </div>
</template>

<script lang="js">
import Vue from 'vue'
import store from '@/store'
import {eventBus} from "@/main";
import { saveAlertPortalAgencyLink } from '@/services/location-request'

export default Vue.extend({
    data() {
        return {
            isModalShowing: false,
            numbers: [],
            newNumbers: '',
            newLink: '',
            newLinkTitle: '',
            agencyLinkSaving: false,
            agencyLinkSaved: false,
            languageValues: ['English', 'Spanish', 'Portuguese', 'French', 'Mandarin', 'German', 'Italian'],
            smsContentValues: ['Standard', 'Custom'],
            smsContentValue: 'Standard',
            isCustomModalOpen: false,
            customSmsText: '',
        }
    },
    methods: {
        openModal() {
            this.isModalShowing = true
        },
        cancelModal() {
            this.isModalShowing = false
            window.location.reload()
        },
        addNumber() {
            if (this.numbers) {
                 if(this.newNumbers[0] == '+'){ //if international
                    this.numbers.push(
                        this.newNumbers,
                    );
                }
                else{ //else domestic
                    this.newNumbers = '+1' + this.newNumbers
                    this.numbers.push(
                        this.newNumbers
                    )
                }
                this.newNumbers = '';
            }
        },
        removeNumber(number) {
            const index = this.numbers.indexOf(number);
            if (index !== -1) {
                this.numbers.splice(index, 1);
            }
        },
        commitAndSubmitNumbers() {
            eventBus.$emit('startNumbersSearch', this.numbers)
            store.commit('location/callList', this.numbers)
            store.dispatch('location/requestMultipleLocations')
            this.isModalShowing = false
        },
        async copyWeaLink() {
            if (this.weaLink) {
                await navigator.clipboard.writeText(this.weaLink)
            }
        },
        async createWEALink() {
            store.dispatch('location/createWeaLink', this.teamId)
        },
        async saveAgencyLandingLink() {
            const uuid = store.state.location.connectionRequest?.uuid
            if (!uuid || !this.newLink.trim()) return
            this.agencyLinkSaving = true
            this.agencyLinkSaved = false
            try {
                await saveAlertPortalAgencyLink({
                    connectionRequestUuid: uuid,
                    link: this.newLink,
                    title: this.newLinkTitle,
                })
                this.agencyLinkSaved = true
            } finally {
                this.agencyLinkSaving = false
            }
        },
        closeModal() {
            this.isModalShowing = false
        },
        cancelCustomModal() {
            this.isCustomModalOpen = false
            this.smsContentValue = 'Standard'
            this.customSmsText = ''
            store.commit('location/setCustomSmsText', '')
        },
        saveCustomModal() {
            store.commit('location/setCustomSmsText', this.customSmsText)
            this.isCustomModalOpen = false
        },
    },
    watch: {
        isModalShowing(isOpen) {
            if (isOpen) {
                const lang = this.smsLanguageForLocale
                store.commit('location/setLanguage', lang)
                store.commit('location/setDeepLLanguage', lang)
                this.smsContentValue = 'Standard'
                this.isCustomModalOpen = false
                this.customSmsText = ''
                store.commit('location/setCustomSmsText', '')
            }
        },
        smsContentValue(value) {
            if (value === 'Custom') {
                this.customSmsText = store.state.location.customSmsText || ''
                this.isCustomModalOpen = true
            } else {
                this.isCustomModalOpen = false
            }
        },
    },
    computed: {
        smsLanguageForLocale() {
            const locale = this.$i18n?.locale || 'en'
            const map = { en: 'English', es: 'Spanish', pt: 'Portuguese', fr: 'French', de: 'German', it: 'Italian' }
            return map[locale] || 'English'
        },
        languageItems() {
            const keys = { English: 'english', Spanish: 'spanish', Portuguese: 'portuguese', French: 'french', Mandarin: 'mandarin', German: "german", Italian: "italian" }
            return this.languageValues.map(value => ({
                value,
                text: this.$t(`modals.languages.${keys[value]}`),
            }))
        },
        smsContentItems() {
            const keys = { Standard: 'standard', Custom: 'custom' }
            return this.smsContentValues.map(value => ({
                value,
                text: this.$t(`modals.smsContentValues.${keys[value]}`),
            }))
        },
        picked: {
            get() {
                return store.state.location.language
            },
            set(value) {
                store.commit(`location/setLanguage`, value)
                store.commit(`location/setDeepLLanguage` , value)
            },
            teamId() {
                return store.state.authentication.teams[0].id
            }
        },
        messageTypeSelection: {
            get() {
                return store.state.location.overwatchMessageType;
            },
            set(value) {
                store.commit('location/setOverwatchMessageType', value)
            }
        },
        teamId() {
            return store.state.authentication.teams[0].id;
        },
        weaLink() {
            return store.state.location.weaLink;
        }
    }
})
</script>

<style>

.input-group-field {
    width: 100%;
    max-width: 45rem;
    /* height: 40px; */
    padding: 1em;
    margin: 1em auto;
    background-color: lightgray;
    color: black;
    box-shadow: 0px .25rem 1rem rgba(black, .50);
    border-radius: 5px;
    outline: none;
}

.alert-mode-section {
    text-align: center;
    padding: 16px 24px 20px;
    min-height: 56px;
    box-sizing: border-box;
}

.wea-link-field {
    display: block;
    padding: 0.5em 0.75em;
    margin: 0.75em auto 0;
    font-size: 12px;
    line-height: 1.35;
    font-weight: 500;
    word-break: break-all;
    user-select: all;
    cursor: default;
}

.wea-link-actions {
    margin-top: 10px;
}

.dispatcher-link-section {
    margin-top: 16px;
    padding-top: 14px;
    border-top: 1px solid #ddd;
}

.dispatcher-link-title-field,
.dispatcher-link-field {
    display: block;
    width: 100%;
    max-width: 45rem;
    margin: 0 auto;
    padding: 0.5em 0.75em;
    font-size: 12px;
    line-height: 1.35;
    font-weight: 500;
    text-align: center;
    background-color: lightgray;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.18);
    border-radius: 5px;
    border: none;
    box-sizing: border-box;
    font-family: inherit;
}

.dispatcher-link-title-field {
    height: 3em;
    min-height: 3em;
    max-height: 3em;
    margin-bottom: 9px;
}

.dispatcher-link-field {
    height: 3em;
    min-height: 3em;
    max-height: 3em;
    resize: none;
    overflow: hidden;
}

.save-agency-link-btn {
    margin-top: 10px;
}

.numbers-container {
    overflow-y: auto;
    max-height: 300px;
    padding: 10px 24px 60px 24px !important;
}

.number-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 12px;
    margin-bottom: 6px;
    background-color: #f5f5f5;
    border-radius: 5px;
    /* border: 1px solid #e0e0e0; */
    transition: all 0.2s ease;
}

.number-item:last-child {
    margin-bottom: 0;
}

.number-text {
    font-size: 13px;
    font-weight: 500;
    color: #333;
    flex: 1;
    text-align: left;
    /* font-family: 'Roboto Mono', monospace; */
    letter-spacing: 0.3px;
}

.remove-number-btn {
    min-width: 20px !important;
    width: 20px !important;
    height: 20px !important;
    margin-left: 8px;
    padding: 0 !important;
    background-color: #ff5252 !important;
    color: white !important;
    border-radius: 50% !important;
    transition: all 0.2s ease;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
}

.remove-number-btn:hover {
    background-color: #ff1744 !important;
    transform: scale(1.1);
    box-shadow: 0 2px 8px rgba(255, 82, 82, 0.4);
}

.remove-x {
    color: white !important;
    font-size: 16px !important;
    font-weight: bold !important;
    line-height: 1 !important;
    display: block !important;
    margin: 0 !important;
    padding: 0 !important;
}

.v-dialog>.v-card>.v-card__text {
    padding: 0 24px 0 24px;
}



.empty-state-alert {
    font-size: 13px !important;
}

.message-type-section {
    padding: 20px 24px 12px 24px !important;
}

.message-type-container {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    width: 100%;
}

.message-type-option {
    display: flex;
    align-items: center;
    cursor: pointer;
    padding: 8px 16px;
    border-radius: 4px;
    transition: all 0.2s ease;
    font-weight: 300;
}

.message-type-option:hover {
    background-color: rgba(0, 0, 0, 0.04);
    font-weight: 300;
}

.message-type-option.active {
    background-color: rgba(25, 118, 210, 0.08);
    font-weight: 300;
}

.message-type-radio {
    margin-right: 8px;
    cursor: pointer;
    font-weight: 300;
}

.message-type-label {
    font-size: 13px;
    font-weight: 500;
    color: #333;
    cursor: pointer;
    user-select: none;
}

.message-type-option.active .message-type-label {
    color: #1976d2;
    font-weight: 600;
}

</style>
